module.exports = "<p>\r\n  awsop-lab7 works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab7/awsop-lab7.component.html
// module id = ./src/app/course/labs/awsop/awsop-lab7/awsop-lab7.component.html
// module chunks = main